let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8qEBZ")).then(() => parcelRequire('l8mXT'));